module.exports = __webpack_public_path__ + "img/Sec_Study_man.1bc9d16f.jpg";